export default __webpack_public_path__ + "static/bmw-logo.b8c482af.svg";